













































import { Component, Prop, Vue } from "vue-property-decorator";

interface Page {
  id: number;
  name: string;
}

interface Content {
  id: number;
  name: string;
  pages: Page[];
}

interface Book {
  id: number;
  name: string;
  contents: Content[];
}

@Component
export default class BookNavigation extends Vue {
  @Prop({ required: true }) readonly data!: Book;

  @Prop()
  private isLoading!: boolean;
  private selectedPage: number | null = null;
  private expandedSections: number[] = [];
  private searchQuery = "";

  get filteredContents(): Content[] {
    const q = this.searchQuery.trim().toLowerCase();
    if (!q) {
      return this.data.contents;
    }

    return this.data.contents
      .map((section) => {
        const sectionMatches = section.name.toLowerCase().includes(q);
        const matchedPages = section.pages.filter((p) => p.name.toLowerCase().includes(q));
        // If the section itself matches, show all its pages
        return sectionMatches ? section : { ...section, pages: matchedPages };
      })
      .filter((section) => {
        // keep section if it matched by name OR has any matched pages
        return section.name.toLowerCase().includes(q) || section.pages.length > 0;
      });
  }

  private displaySection(section: any) {
    if (!this.isExpanded(section.id)) {
      this.toggleSection(section.id);
    }
    this.$emit("show-section", section);
  }

  private toggleSection(id: number): void {
    const index = this.expandedSections.indexOf(id);
    if (index >= 0) {
      this.expandedSections.splice(index, 1);
    } else {
      this.expandedSections.push(id);
    }
  }

  private handlePageClick(section: any, pageId: number): void {
    this.selectedPage = pageId;
    this.$emit("show-page", { pageId, section });
  }

  private isExpanded(id: number): boolean {
    return this.expandedSections.includes(id);
  }
}
